import React from 'react'
import PropTypes from 'prop-types'

function SectionTitle({ titleText, subtitleText, subtitle, textAlignment ,customClassNames}) {
    return (
        <div className={`text-${textAlignment} ${customClassNames}`}>
            <h2 className='font-bebas text-4xl md:text-5xl lg:text-title2 leading-[40px] md:leading-[50px] lg:leading-[60px]'>{titleText}</h2>
            {subtitle && <p className='text-body font-poppins'>{subtitleText}</p>}
        </div>
    )
}

SectionTitle.propTypes = {
    titleText: PropTypes.string.isRequired,
    subtitleText: PropTypes.string,
    subtitle: PropTypes.bool,
    textAlignment: PropTypes.string,
    customClassNames: PropTypes.string
}

SectionTitle.defaultProps = {
    subtitle: false,
    textAlignment: 'center' || 'start' || 'end',
    subtitleText: 'this is the sub title text',
    titleText: 'this is the title text'
}

export default SectionTitle